import { ChangeDetectorRef, Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { MdbTableDirective, MdbTablePaginationComponent, ModalDirective } from 'angular-bootstrap-md';
import { AlertService } from 'ngx-alerts';
import { FormaPagoService } from '../forma-pago.service';
import { formaPago } from '../formaPago';

@Component({
  selector: 'app-forma-pago',
  templateUrl: './forma-pago.component.html',
  styleUrls: ['./forma-pago.component.scss']
})
export class FormaPagoComponent implements  OnInit {
  formaPAgo: formaPago[] = [];
  formaPagoActualizar: formaPago;
  listaformaPagoActulizar: formaPago[] = [];
  editForm: FormGroup;
  @ViewChild(MdbTablePaginationComponent) mdbTablePagination: MdbTablePaginationComponent;
  @ViewChild(MdbTableDirective) mdbTable: MdbTableDirective
  @ViewChild('processingModal') public mdbModal: ModalDirective;
  data: formaPago[] = [];
  previous: any = [];
  isLoadingResults = true;

  constructor(private alertService: AlertService,private api: FormaPagoService, private cdRef: ChangeDetectorRef, private formBuilder: FormBuilder, private ruter: Router) { }
  searchText: string = '';
  @HostListener('input') oninput() {
    this.searchItems();
  }


  mensaje(unid: formaPago) {



        this.editForm.controls.descripcion.setValue(unid.descripcion);
        this.editForm.controls.id.setValue(unid.id);
        this.editForm.controls.codigoSri.setValue(unid.codigoSri);
        
    this.mdbModal.show();

  }


listar(){

  this.api.getformaPago(localStorage.getItem('id'))
  .subscribe((
    data: formaPago[]) => {
    this.formaPAgo = data;
    console.log(this.formaPAgo);
    this.mdbTable.setDataSource(this.formaPAgo);
    this.mdbTable.dataSourceChange();
    this.previous = this.mdbTable.getDataSource();
  }
    , err => {
      console.log(err);
      this.isLoadingResults = false;
    });
}


  ngOnInit() {

    this.listar();

    this.editForm = this.formBuilder.group({
      descripcion: ['', Validators.required],
     codigoSri:[''],
      id: [0, Validators.required]
     
    });


  }
  eliminarCliente(id: number) {
    this.api.eliminar(id).subscribe(

      data  => {
        this.alertService.success("Se elimino con exito..")
        this.listar();

      
      },
      
      error  => {
      
     this.alertService.danger(error)
      
      }
      
      );

  }

  agregar() {
    this.editForm = this.formBuilder.group({
      id: [0],
      descripcion: ['', Validators.required],
           codigoSri:[''],
    });

    this.mdbModal.show();
    this.listar();
  }


  actulizar() {
    this.formaPagoActualizar = new formaPago();
    this.formaPagoActualizar.id=this.editForm.controls.id.value;
    this.formaPagoActualizar.descripcion=this.editForm.controls.descripcion.value;
    this.formaPagoActualizar.idEmisor = Number(localStorage.getItem('id'));
    this.formaPagoActualizar.codigoSri =this.editForm.controls.codigoSri.value;
    this.listaformaPagoActulizar[0] = this.formaPagoActualizar;
   
    this.api.setActulizar(this.listaformaPagoActulizar).subscribe(

      data  => {
        this.alertService.success("Se actualizo con exito..")
        this.mdbModal.hide();
        this.listar();
      
      },
      
      error  => {
      
     this.alertService.danger(error)
      
      }
      
      );
  


  }

  // tslint:disable-next-line:use-life-cycle-interface
  ngAfterViewInit() {
    this.mdbTablePagination.setMaxVisibleItemsNumberTo(5);

    this.mdbTablePagination.calculateFirstItemIndex();
    this.mdbTablePagination.calculateLastItemIndex();
    this.cdRef.detectChanges();
  }


  searchItems() {
    const prev = this.mdbTable.getDataSource();

    if (!this.searchText) {
      this.mdbTable.setDataSource(this.previous);
      this.formaPAgo = this.mdbTable.getDataSource();
    }

    if (this.searchText) {
      this.formaPAgo = this.mdbTable.searchLocalDataBy(this.searchText);
      this.mdbTable.setDataSource(prev);
    }
  }

}
